import { render, staticRenderFns } from "./Richieste.vue?vue&type=template&id=691bb11f&scoped=true&"
import script from "./Richieste.vue?vue&type=script&lang=js&"
export * from "./Richieste.vue?vue&type=script&lang=js&"
import style0 from "./Richieste.vue?vue&type=style&index=0&id=691bb11f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bb11f",
  null
  
)

export default component.exports